<template>
<div class="vliveContentVideos">
    <div  class="video-list">
        <div class="video" v-for="(video, index) in videoList" :key="index">
            <img :src="video.coveratturl" alt="">
            <!--<video :src="video.fileatturl"></video>-->
            <span class="title">{{video.name}}</span>
        </div>
    </div>
    <page :total="total" @getList="_getList"></page>
</div>
</template>

<script>
import {findGroupVideo} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import Page from 'base/page/page'
export default {
    name: 'vliveContentVideos',
    data() {
        return {
            videoList: [],
            total: 0,
            param: {
                catalogInnerId: '', // 图片分类的innerid
                hostinfoinnerid: '' // 主办方innerid
            }
        }
    },
    mounted() {
        this.param.hostinfoinnerid = this.user.hostinnerid
    },
    methods: {
        // 获取视频合集
        _getGroupVideo(catalogInnerId) {
            this.param.catalogInnerId = catalogInnerId
            this._getList()
        },
        _getList() {
            this.setLoading(true)
            findGroupVideo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.vliveModel.contentList.forEach(obj => {
                        if (obj.columntype === 2) {
                            obj.videoList = this.videoList.concat(data.data)
                        }
                    })
                    this.setVliveModelContentList(this.vliveModel.contentList)
                    this.videoList = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setVliveModelContentList'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'vliveModel',
            'user',
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveContentVideos {
    .video-list{
        .video{
            margin-bottom: 20px;
            @include flexBox(flex-start);
            img{
                max-width: 160px;
                min-width: 160px;
                height: 90px;
                margin-right: 10px;
            }
            .title{
                align-self: flex-start;
            }
        }
    }
}
</style>
